import type { IconName } from '@wtfalch/design';
import { Icon } from '@wtfalch/design';
import type { MailboxRole } from '@wtfalch/email/mailbox';

import { Stroke } from '../ui/icons.tsx';

/**
 * `archive` is not in `@wtfalch/design`'s `IconName` set -- see `ui/icons.tsx`
 * for the shared `Stroke` wrapper this draws with, and for `filter`, which
 * Chat needs too and so lives there instead of here.
 */
export function ArchiveIcon({ size }: { size?: number }) {
  return (
    <Stroke
      size={size}
      d="M3.2 5.4h17.6v3.2H3.2zM4.8 8.6v10a1.4 1.4 0 0 0 1.4 1.4h11.6a1.4 1.4 0 0 0 1.4-1.4v-10M9.6 12.4h4.8"
    />
  );
}

const ROLE_ICON: Partial<Record<MailboxRole, IconName>> = {
  inbox: 'mail',
  drafts: 'pen',
  sent: 'send',
  trash: 'trash',
  junk: 'junk',
  flagged: 'star-filled',
};

/** A mailbox's icon by role, shared between the list head's own mailbox
 *  picker (`MailList.tsx`) and the folder column (`MailFolders.tsx`) so the
 *  two never draw the same folder two different ways. */
export function MailboxIcon({ role, size = 15 }: { role: MailboxRole | null; size?: number }) {
  if (role === 'archive') return <ArchiveIcon size={size} />;
  const name = (role && ROLE_ICON[role]) || 'mail';
  return <Icon name={name} size={size} />;
}
